export default "__VITE_ASSET__8a9a8d14__"